import { Injectable } from '@angular/core';
import Dexie from 'dexie';

@Injectable({
  providedIn: 'root',
})
export class AppDatabaseService extends Dexie {
  constructor() {
    super('landify-database');

    this.version(1).stores({
      users: 'id',
      active_user: 'id',
    });
  }
}
